import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export const fetchUsers = createAsyncThunk(
  'users/fetchAll',
  async (includeInactive = false, { rejectWithValue }) => {
    try {
      const res = await apiService.getUsers(includeInactive);
      // Handle both { data: [...] } and direct [...] response formats
      return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const createUser = createAsyncThunk(
  'users/create',
  async (user, { rejectWithValue }) => {
    try {
      const res = await apiService.createUser(user);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/update',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await apiService.updateUser(id, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/delete',
  async (id, { rejectWithValue }) => {
    try {
      const res = await apiService.deleteUser(id);
      return { id, deactivated: !!res?.deactivated };
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: { list: [], loading: false, error: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => { state.loading = true; })
      .addCase(fetchUsers.fulfilled, (state, action) => { state.list = action.payload; state.loading = false; })
      .addCase(fetchUsers.rejected, (state) => { state.loading = false; })
      .addCase(createUser.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateUser.fulfilled, (state, action) => {
        const i = state.list.findIndex((u) => u.id === action.payload.id);
        if (i >= 0) state.list[i] = action.payload;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const { id, deactivated } = action.payload;
        if (deactivated) {
          const i = state.list.findIndex((u) => u.id === id);
          if (i >= 0) state.list[i] = { ...state.list[i], status: false };
        } else {
          state.list = state.list.filter((u) => u.id !== id);
        }
      });
  },
});

export default usersSlice.reducer;
